import LandingMetaTags from '../components/landing/LandingMetaTags'
import LandingNavigation from '../components/landing/LandingNavigation'
import LandingHero from '../components/landing/LandingHero'
import LandingFounder from '../components/landing/LandingFounder'
import LandingProblems from '../components/landing/LandingProblems'
import LandingProcessComparison from '../components/landing/LandingProcessComparison'
import LandingFeatures from '../components/landing/LandingFeatures'
import LandingROICalculator from '../components/landing/LandingROICalculator'
import LandingUseCases from '../components/landing/LandingUseCases'
import LandingSecurity from '../components/landing/LandingSecurity'
import LandingPricing from '../components/landing/LandingPricing'
import LandingContact from '../components/landing/LandingContact'
import LandingFooter from '../components/landing/LandingFooter'
import './LandingPage.css'

function LandingPage () {
  // Scroll to section smoothly
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className='lp-landing-page'>
      <LandingMetaTags />
      <LandingNavigation scrollToSection={scrollToSection} />
      <LandingHero scrollToSection={scrollToSection} />
      <LandingFounder />
      <LandingProblems />
      <LandingProcessComparison />
      <LandingFeatures />
      <LandingROICalculator />
      <LandingUseCases />
      <LandingSecurity />
      <LandingPricing />
      <LandingContact />
      <LandingFooter />
    </div>
  )
}

export default LandingPage
